<template>
        <section class="page-section" id="menus">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Menus</h2>
                    <h3 class="section-subheading text-muted">Gute Küche braucht Zeit...</h3>
                </div>
                <div class="row text-center">
                    <div class="col-md-3" v-for="(obj, key) in menuJSON" :key=key>
                        <!-- <a class="nav-link js-scroll-trigger" :href="obj.pdfurl" target="_blank"> -->
                        <a class="nav-link js-scroll-trigger">
                        <span class="fa-stack fa-4x"><i class="fas fa-circle fa-stack-2x text-primary"></i><i :class="obj.imgclass"></i></span>
                        <h4 class="my-3">{{ obj.title }}</h4></a>
                        <p class="text-muted">{{ obj.caption }}</p>
                    </div>
                </div>
                <div class="text-center">
                    <h4 class="text-muted">Nur Barzahlung möglich</h4>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    data: () => ({
        menuJSON: [
            {
                title: 'Essen',
                caption: 'Öfters mal was Neues.',
                //pdfurl: './pdf/SpeiseKarte_Bar_Barriere_23.pdf',
                imgclass: 'fas fa-utensils fa-stack-1x fa-inverse'             
            },
            {
                title: 'Getränke',
                caption: 'Für den gesunden Durst.',
                //pdfurl: './pdf/GetraenkeKarte_Bar_Barriere_20.pdf',
                imgclass: 'fas fa-cocktail fa-stack-1x fa-inverse'             
            },
            {
                title: 'Dessert',
                caption: 'Eine süsse Versuchung.',
                //pdfurl: './pdf/GlaceKarte_Bar_Barriere_20.pdf',
                imgclass: 'fas fa-heart fa-stack-1x fa-inverse'             
            },
            {
                title: 'Winterkarte',
                caption: 'Für einen coolen Winter.',
                //pdfurl: './pdf/WinterKarte_Bar_Barriere_23.pdf',
                imgclass: 'fas fa-snowflake fa-stack-1x fa-inverse'             
            }
            //{
            //     title: 'Sommerkarte',
            //     caption: 'Für einen heissen Sommer.',
            //     pdfurl: './pdf/SommerKarte_Bar_Barriere_23_2.pdf',
            //     imgclass: 'fas fa-umbrella-beach fa-stack-1x fa-inverse'             
            //}
        ]

    })      
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
h4 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #000000;
}
</style>